import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIConstants } from '../../common';
import { Observable, Subject } from 'rxjs';
import { IContents, IFileExlorerPaginationResponse, IFilteredFileExlorerPaginationResponse, IFolder, IMoveContent, IResponseMessage } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class FileExplorerService {

  addContentToComposition: Subject<IContents[]> = new Subject<IContents[]>;
  refreshContentPage: Subject<void> = new Subject<void>;

  constructor(private http: HttpClient) { }

  getAllFolders(): Observable<IFileExlorerPaginationResponse> {
    return this.http.get<IFileExlorerPaginationResponse>(APIConstants.folders);
  }

  getAllFolderMediaByLimit(limit: number, offset: number): Observable<IFileExlorerPaginationResponse> {
    const url = APIConstants.mediaFolders + '?limit=' + limit + '&offset=' + offset;
    return this.http.get<IFileExlorerPaginationResponse>(url);
  }

  getAllFoldersByLimit(limit: number, offset: number): Observable<IFileExlorerPaginationResponse> {
    const url = APIConstants.folders + '?limit=' + limit + '&offset=' + offset;
    return this.http.get<IFileExlorerPaginationResponse>(url);
  }

  getFilteredFoldersByLimit(limit: number, offset: number, folder_id: string, category: string, search?: string, ordering?: string): Observable<IFilteredFileExlorerPaginationResponse> {
    let url = APIConstants.foldersFiltered + '?limit=' + limit + '&offset=' + offset + '&folder_id=' + folder_id + '&category=' + category;
    if (search) {
      url += '&search=' + encodeURIComponent(search);
    }
    if (ordering) {
      url += '&ordering=' + encodeURIComponent(ordering);
    }
    return this.http.get<IFilteredFileExlorerPaginationResponse>(url);
  }

  getAllFilteredFolders(folder_id: string, category: string): Observable<IFilteredFileExlorerPaginationResponse> {
    const url = APIConstants.foldersFiltered + '?folder_id=' + folder_id + '&category=' + category;
    return this.http.get<IFilteredFileExlorerPaginationResponse>(url);
  }

  createFolder(folder: IFolder): Observable<IResponseMessage> {
    return this.http.post<IResponseMessage>(APIConstants.folders, folder);
  }

  renameFolder(folder: IFolder, folder_id: number): Observable<IResponseMessage> {
    return this.http.put<IResponseMessage>(APIConstants.folders + folder_id + '/', folder);
  }

  moveToFolder(folder_id: number | null, file_ids: number[]): Observable<IResponseMessage> {
    const moveContent = {} as IMoveContent;
    moveContent.folder_id = folder_id;
    moveContent.content_ids = file_ids;
    return this.http.post<IResponseMessage>(APIConstants.moveContent, moveContent);
  }

  deleteFolderById(folder_id: number): Observable<IResponseMessage> {
    return this.http.delete<IResponseMessage>(APIConstants.folders + folder_id + '/');
  }

}
